import { ExprError } from '@mode-switch/express';
import { ExprPath } from '@mode-switch/express';
import { Pipeline } from '../Pipeline';
export var DataPaths;
(function (DataPaths) {
    function make() {
        return (pipeline, node) => {
            switch (node.type) {
                case "Identifier":
                case "AccessIdentifier":
                case "AccessExpression":
                    const path = ExprPath.fromParseNode(node);
                    if (path.type === "EMPTY") {
                        return new ExprError.InvalidAccess([], 'cannot be empty');
                    }
                    return Pipeline.Paths.set(pipeline, node, path);
                default:
                    return pipeline;
            }
        };
    }
    DataPaths.make = make;
})(DataPaths || (DataPaths = {}));
